import React, { useEffect, useState } from "react";
import { reportCardMailHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MainPopup from "../popup-containers/MainPopup";

import toast from "react-hot-toast";
import { BindAPI, IUDAPI, ImageAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import FileUpload from "../ReusableComponents/FileUpload";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import MultiSelect from "../ReusableComponents/MultiSelect";
import ViewPopup from "../popup-containers/ViewPopup";
import AssessmentReportPopup from "../popup-containers/AssessmentReportPopup";
import Loader from "../ReusableComponents/Loader";

const AssessmentReport = () => {
  const location = useLocation();
  const [assessmentReportFields, setAssessmentReportFields] = useState({
    company: [],
    valueChainPartner: "",
    date: "",
    showImage: "",
  });
  const [assessmentReportFieldsError, setAssessmentReportFieldsError] =
    useState({
      companyError: "",
      valueChainPartnerError: "",
      showImageError: "",
    });
  const createdBy = sessionStorage.getItem("createdBy");
  const [assessmentReportPopupData, setAssessmentReportPopupData] = useState(
    []
  );
  const [assessmentReportPopupData1, setAssessmentReportPopupData1] = useState(
    []
  );
  // bind system setting
  const [bindSystemSettingsData, setBindSystemSettingsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const [vcp, setVCP] = useState("");
  const [company, setCompany] = useState("");
  // Bind Dropdown Values
  const [bindCompanyDatas, setCompanyDatas] = useState([]);
  const [bindChainPartnerDatas, setChainPartnerDatas] = useState([]);
  const [filteredTypeCList, setFilteredTypeCList] = useState([]);
  const [filteredVCPList, setFilteredVCPList] = useState([]);

  const [bindAssessmentReportDatas, setBindAssessmentReportDatas] = useState(
    []
  );

  // Bind Company and Value Chain Partner dropdown values start

  useEffect(() => {
    const BindCompanyAndChainPartnerDropdown = async () => {
      const bindReferredBydatadrp = await BindAPI("PartnerAPI/BindPartner");
      const filteredData = bindReferredBydatadrp.data.Table3;
      const response = await BindAPI(
        "AssessmentReportAPI/BindAssessmentReport"
      );
      const filteredWithInActivatedByNull = filteredData.filter(
        (item) => item.Status === "Active"
      );
      const filteredWithTypeC = filteredWithInActivatedByNull.filter(
        (item) => item.Type === "C"
      );
      const filteredWithTypeVCP = filteredWithInActivatedByNull.filter(
        (item) => item.Type === "VCP"
      );

      setFilteredTypeCList(response.data.Table1); // Store Type C for filtering later
      setFilteredVCPList(filteredWithTypeVCP); // Store Type VCP
      bindChainPartnerData(filteredWithTypeVCP); // Bind to dropdown
    };
    BindCompanyAndChainPartnerDropdown();
  }, []);
  useEffect(() => {
    if (
      assessmentReportFields.valueChainPartner &&
      filteredTypeCList.length > 0
    ) {
      const filteredCompanies = filteredTypeCList.filter(
        (company) =>
          company.MstValueChainPartnerId ==
          assessmentReportFields.valueChainPartner
      );

      const formattedCompanies = filteredCompanies.map((m) => ({
        value: m.MstCompanyId,
        label: `${m.PartnerName} ${m.Type}`,
      }));

      setCompanyDatas(formattedCompanies);
    } else {
      setCompanyDatas([]);
    }
  }, [assessmentReportFields.valueChainPartner, filteredTypeCList]);

  const bindChainPartnerData = async (resultdata) => {
    try {
      if (resultdata.length > 0) {
        const CompanyAndChainPartnerDD = resultdata.map((m) => ({
          value: m.MstPartnerId,
          label: `${m.PartnerName} ${m.Type}`,
        }));
        setChainPartnerDatas(CompanyAndChainPartnerDD);
      } else {
        setChainPartnerDatas([]);
      }
    } catch (error) {
      console.error("Error fetching CompanyAndChainPartner data:", error);
    }
  };

  const customerChange1 = (updatedOptions) => {
    const selectedItems = bindCompanyDatas.filter((item) =>
      updatedOptions.includes(item.value)
    );
    setAssessmentReportFields((prevFields) => ({
      ...prevFields,
      company: selectedItems,
    }));

    if (updatedOptions.length > 0) {
      setAssessmentReportFieldsError({
        companyError: "",
      });
    }
  };

  useEffect(() => {
    BindPartnerMappingGridData();
    systemSettingsData();
  }, []);


  const systemSettingsData = async () => {
    const response = await BindAPI("SystemSettingsAPI/BindSystemSettings");

    setBindSystemSettingsData(response.data.Table);
  };

  const BindPartnerMappingGridData = async () => {
    setIsLoading(true);
    const response = await BindAPI("AssessmentReportAPI/BindAssessmentReport");
    setBindAssessmentReportDatas(response.data.Table);
    setIsLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      setAssessmentReportFields({
        ...assessmentReportFields,
        date: formattedDate,
      });
    };

    fetchData();
  }, []);

  const handleAssessmentReportFieldsChange = (value, name) => {
    setAssessmentReportFields({
      ...assessmentReportFields,
      [name]: value,
    });
  };
  const [sendScreenTitle, setSendScreenTitle] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setAssessmentReportFields({
      ...assessmentReportFields,
      date: formattedDate,
    });
    localStorage.setItem("screenMode", "add");
  };

  const cancel = () => {
    setIsLoading(false);
    BindPartnerMappingGridData();
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setSubmitVisibleButton(false);
    clear();
    localStorage.setItem("screenMode", "");
  };
  const clear = () => {
    setCompany("");
    setVCP("");
    setAssessmentReportFields({
      company: [],
      valueChainPartner: "",
      date: "",
      showImage: "",
    });
    setAssessmentReportFieldsError({
      companyError: "",
      valueChainPartnerError: "",
      showImageError: "",
    });
  };

  const handleShowImage = (showImage) => {
    setAssessmentReportFields({
      ...assessmentReportFields,
      showImage: showImage || "",
    });

    setAssessmentReportFieldsError({
      ...assessmentReportFieldsError,
      showImageError: "",
    });
  };

  const handleEdit = async (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex);
    const rowData = bindAssessmentReportDatas[rowIndex];
    const CompanyIds = rowData.MstCompanyIds.split(",");
    const uniqueCompanyMap = new Map();

    filteredTypeCList
      .filter((item) => CompanyIds.includes(String(item.MstCompanyId)))
      .forEach((m) => {
        if (!uniqueCompanyMap.has(m.MstCompanyId)) {
          uniqueCompanyMap.set(m.MstCompanyId, {
            value: m.MstCompanyId,
            label: `${m.PartnerName} ${m.Type}`,
          });
        }
      });

    const matchedCompany = Array.from(uniqueCompanyMap.values());

    var customerDate = bindAssessmentReportDatas[rowIndex].Date;
    const customerDatePart = customerDate.split("T")[0];
    setAssessmentReportFields({
      ...assessmentReportFields,
      company: matchedCompany || [],
      valueChainPartner:
        bindAssessmentReportDatas[rowIndex].MstValueChainPartnerId,
      showImage: bindAssessmentReportDatas[rowIndex].AttachmentFile,
      date: customerDatePart,
    });
  };

  const handleAssessmentReport = (rowIndex, flag) => {
    setpopUpOpen(true);

    const rowData = bindAssessmentReportDatas[rowIndex];

    var customerDate = bindAssessmentReportDatas[rowIndex].Date;
    const customerDatePart = customerDate.split("T")[0];
    setAssessmentReportFields({
      ...assessmentReportFields,
      valueChainPartner:
        bindAssessmentReportDatas[rowIndex].MstValueChainPartnerId,
      date: customerDatePart,
    });
    setAssessmentReportPopupData(rowData);
    setAssessmentReportPopupData1(bindSystemSettingsData[0]);

  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const isFormError = {
        ...assessmentReportFieldsError,
        valueChainPartnerError: assessmentReportFields.valueChainPartner
          ? ""
          : "Select Value Chain Partner",
        companyError:
          !assessmentReportFields.company ||
            assessmentReportFields.company.length === 0
            ? "Select Company"
            : "",
        showImageError: assessmentReportFields.showImage
          ? ""
          : "Please Upload Attachment File",
      };

      setAssessmentReportFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        let companyData = [];
        companyData = convertArrayToJSONString(assessmentReportFields.company);

        const customerPayload = [
          {
            assessmentReportId: 0,
            companyId: companyData,
            valueChainPartnerId: assessmentReportFields.valueChainPartner,
            attachmentFile: assessmentReportFields.showImage,
            date: assessmentReportFields.date,
            createdby: createdBy,
            flag: editMode ? 2 : 1,
          },
        ];

        const response = await IUDAPI(
          customerPayload,
          "AssessmentReportAPI/IUDAssessmentReport"
        );
        const value = editMode ? 2 : 1;
        if (flag == value) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Assessment Report send successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setAssessmentReportFields({
              ...assessmentReportFields,
              customerId: response.data.Table1[0].CustomerId,
            });
            setTimeout(cancel, 10000);
          } else {
            toast.error("Failed to send Assessment Report 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (2 == value) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Assessment Report send successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to send Assessment Report 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
    } else {
      const data = {
        assessmentReportId: 0,
        valueChainPartnerId: assessmentReportFields.valueChainPartner,
        date: assessmentReportFields.date,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI(
        [data],
        "AssessmentReportAPI/IUDAssessmentReport"
      );
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Assessment Report data deleted successfully 🗑️",
            5000,
            cancel()
          );
        } else {
          toast.error("Failed to delete Assessment Report data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Assessment Report data Inactived successfully 🚫",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to Inactived Assessment Report data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Assessment Report data Actived successfully ✅",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to Actived Assessment Report data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };

  useEffect(() => {
    if (location.pathname === "/assessmentreport") {
      const screenMode = localStorage.getItem("screenMode");
      if (screenMode === "add") {
        setVisibleAdd(true);
        setVisibleTable(false);
        setAddScreenTitle(true);
        setUpdateScreenTitle(false);
      } else if (screenMode === "edit") {
        const storedIndex = localStorage.getItem("selectedRowIndex");
        if (storedIndex !== null && bindAssessmentReportDatas.length > 0) {
          handleEdit(Number(storedIndex));
        }
      }
    }
  }, [location, bindAssessmentReportDatas]);

  const [companyDetails, setCompanyDetails] = useState([]);

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setCompanyDetails(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };
  const isImageFile = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
    const ext = url?.split(".").pop()?.toLowerCase();
    return imageExtensions.includes(ext);
  };
  const getViewerUrl = (url) => {
    if (!url) return "";
    const extension = url.split(".").pop().toLowerCase();

    return extension === "pdf"
      ? url
      : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        url
      )}`;
  };
  const handleView = (rowIndex) => {
    var AttachmentFile = bindAssessmentReportDatas[rowIndex].AttachmentFile;

    setCompany(bindAssessmentReportDatas[rowIndex].MstCompanyNames);
    setVCP(bindAssessmentReportDatas[rowIndex].PartnerName);
    setSelectedFileUrl(AttachmentFile);
    setShowFileModal(true);
  };

  useEffect(() => {
    setAssessmentReportFields({
      ...assessmentReportFields,
      company: [],
    });
  }, [assessmentReportFields.valueChainPartner]);

  return (
    <MainLayout pageName={"5"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Assessment Report"
          header={reportCardMailHeader}
          records={bindAssessmentReportDatas}
          blockView={false}
          addClientView={true}
          // handleEdit={handleEdit}
          handleAction={handleAssessmentReport}
          // handleSchoolView={handleView}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              sendTitle={true}
              updateScreenTitle={updateScreenTitle}
              title="Assessment Report"
            />

            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={"p-5"}>
                  <div className="flex justify-center">
                    <div className="w-3/4">
                      <div class="grid gap-4 mb-2 md:grid-cols-2">
                        <AutoDropDown
                          title="Value Chain Partner"
                          options={bindChainPartnerDatas}
                          placeholder="Select"
                          name="valueChainPartner"
                          selectedOption={
                            assessmentReportFields.valueChainPartner
                              ? bindChainPartnerDatas.find(
                                (x) =>
                                  x.value ==
                                  assessmentReportFields.valueChainPartner
                              )
                              : ""
                          }
                          Class="custom-class"
                          tabIndex="1"
                          classStar="text-red-500"
                          controlFunc={(value, e) => {
                            handleAssessmentReportFieldsChange(
                              value.value,
                              e.name
                            );

                          }}
                          controlFuncBlur={() => {

                            setAssessmentReportFieldsError(() => ({
                              ...assessmentReportFieldsError,
                              valueChainPartnerError:
                                assessmentReportFields.valueChainPartner
                                  ? ""
                                  : "Select Value Chain Partner",
                            }));
                          }}
                          errorMessage={
                            assessmentReportFieldsError.valueChainPartnerError
                          }
                        />
                        <div>
                          <MultiSelect
                            classStar="text-red-500"
                            label="Company"
                            filteredOptions={bindCompanyDatas}
                            classFilterLabel="p-1 flex gap-1"
                            class="custom-class"
                            placeholder={
                              assessmentReportFields.company?.length > 0
                                ? "More Selected"
                                : "Select..."
                            }
                            name="Company"
                            selectedOptions={
                              assessmentReportFields.company
                                ? assessmentReportFields.company.map(
                                  (item) => item.value
                                )
                                : ""
                            }
                            classDiv="relative w-full inline-block"
                            onChange={customerChange1}
                            classLabel={mainTable.labelNoWrap}
                          />
                          {assessmentReportFieldsError.companyError && (
                            <span className="text-red-500">
                              {assessmentReportFieldsError.companyError}
                            </span>
                          )}

                          {assessmentReportFields.company?.length > 0 && (
                            <div className="mt-2">
                              <div className="flex flex-col gap-2">
                                {assessmentReportFields.company.map(
                                  (item, index) => (
                                    <span
                                      key={index}
                                      className="bg-gray-100 px-2 py-1 w-fit rounded text-sm text-gray-800"
                                    >
                                      {item.label}
                                    </span>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {assessmentReportFields.valueChainPartner && (
                        <FileUpload
                          title="Attachment File"
                          apiCall="AssessmentReportAPI/AssessmentReportImageUpload"
                          modalName="AttachmentFile"
                          name="showImage"
                          classStar="text-red-500"
                          disabledBtn={updateScreenTitle}
                          showImage={assessmentReportFields.showImage}
                          showImageData={handleShowImage}
                          imageUploadedError={
                            assessmentReportFieldsError.showImageError
                          }
                          partnerId={assessmentReportFields.valueChainPartner}
                          imageShow={false}
                          MAX_FILE_SIZE_MB={2}
                          limitMassage={`Attachment file size limit: 2 MB. Accepted file types are PDF, XLS, XLSX, DOC, DOCX, PPT, PPTX, JPG, JPEG, PNG.
                            Please Upload The File After Choosing It.`}
                          ALLOWED_FORMATS={[
                            "image/jpeg",
                            "image/jpg",
                            "image/png",
                            "application/pdf", // for PDFs
                            "application/msword", // for .doc files
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
                            "application/vnd.ms-excel", // for .xls files (older Excel format)
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
                            "application/vnd.ms-powerpoint", // for .ppt files
                            "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
                          ]}
                        />
                      )}
                    </div>
                  </div>
                </form>

                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  viewSaveButton={true}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {showFileModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowFileModal(false)} // Outside click closes modal
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent close on inside click
          >
            <button
              onClick={() => setShowFileModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
            <div className="flex justify-center">
              <form className="overflow-auto p-5  min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
                <div className="w-full space-y-4">
                  <div className="flex">
                    <label className="w-40 font-semibold">To</label>
                    <label>: {vcp}</label>
                  </div>
                  <div className="flex">
                    <label className="w-40 font-semibold">CC</label>
                    <label>: {company}</label>
                  </div>
                  <div className="flex">
                    <label className="w-40 font-semibold">BCC</label>
                    <label>: {bindSystemSettingsData[0].BCC}</label>
                  </div>

                </div>
              </form>
            </div>
            {selectedFileUrl ? (
              isImageFile(selectedFileUrl) ? (
                <img
                  src={selectedFileUrl}
                  alt="Preview"
                  className="w-full h-full object-contain rounded"
                />
              ) : (
                <iframe
                  src={getViewerUrl(selectedFileUrl)}
                  title="File Viewer"
                  className="w-full h-[80vh] rounded"
                />
              )
            ) : (
              <div className="text-center text-gray-500">No file selected</div>
            )}
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Assessment Report"
            setpopUpOpen={setpopUpOpen}
            viewDetails={true}

          />

          <AssessmentReportPopup data={assessmentReportPopupData} data2={assessmentReportPopupData1} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
      <MainPopup
        popUpOpen={showPopup}
        setpopUpOpen={setShowPopup}
        Open={() => setShowPopup(true)}
        loginPopups={true}
      >
        <div>
          <ViewPopup />
        </div>
      </MainPopup>
    </MainLayout>
  );
};

export default AssessmentReport;
